// extracted by mini-css-extract-plugin
export var errorsContainer = "_sw-1";
export var link = "_sw-0";